import { useMutation } from "@tanstack/react-query";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import { requestURLs } from "../../Environment";
import ApiRequest from "../ApiRequest";
import z from "zod";
import { ProjectDataSchema } from "../../project/projectDataSchema";
export const useProjectCreate = () => {
  return useMutation<
    AxiosResponseAndError<string>["response"],
    AxiosResponseAndError<any>["error"],
    z.infer<typeof ProjectDataSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post(requestURLs.createExle, JSON.stringify(data)),
  });
};
